<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <div class="lr between">
          <div style="display: flex;justify-content: space-between;">
            <el-date-picker
              v-model="table.query.feeYear"
              type="year"
              placeholder="请选择年份"
              value-format="yyyy"
              @change="search(true)">
            </el-date-picker>
            <el-date-picker
              class="ml20"
              v-model="table.query.feeDate"
              type="month"
              placeholder="请选择月份"
              value-format="yyyy-MM"
              @change="search(true)">
            </el-date-picker>
          </div>
          <div style="display: flex;justify-content: flex-end;">
            <el-button type="primary" size="small" @click="openDialog(null, false)"
                       icon="el-icon-plus">新增
            </el-button>
            <div style="display: flex;justify-content: flex-end;">
              <el-button type="primary" size="small" @click="handleExcelExport"
                         icon="el-icon-download" class="ml20">导出
              </el-button>
            </div>
          </div>
        </div>
        <div class="main" style="margin-top: 20px;">
          <el-table :data="table.data" height="600px" border
                    :header-cell-style="{background:'#fafafa',color:'#000000'}" v-loading="tableLoading">
            <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                             align="center"/>
            <el-table-column show-overflow-tooltip label="总收电费" align="center"
                             prop="electricTotal"></el-table-column>
            <el-table-column show-overflow-tooltip label="总收水费" align="center"
                             prop="waterTotal"></el-table-column>
            <el-table-column show-overflow-tooltip label="总交电费" align="center"
                             prop="payWaterTotal"></el-table-column>
            <el-table-column show-overflow-tooltip label="总交水费" align="center"
                             prop="payElectricTotal"></el-table-column>
            <el-table-column show-overflow-tooltip label="利润" align="center"
                             prop="income"></el-table-column>
            <el-table-column show-overflow-tooltip label="费用日期" align="center"
                             prop="feeDate"></el-table-column>
            <el-table-column show-overflow-tooltip label="操作" width="210" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="openDialog(scope.row, true)">编辑</el-button>
                <el-button type="text" style="color: #ff4949;" @click="deleteData(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="lr end" style="margin-top: 20px;">
          <el-pagination :total="table.total" :page-size="table.query.size" :current-page="table.query.page"
                         layout="total, prev, pager, next" @current-change="currentPageChange"/>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="otherFeeDialog.visible" :close-on-click-modal="false" width="30%"
               :title="!isEdit ? '新增水电收支' : '编辑水电收支'">
      <el-form ref="otherFeeForm" label-position="right" label-width="120px" :model="otherFeeDialog.formData"
               :rules="rules">
        <el-form-item label="总收电费：" prop="electricTotal">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%" v-model="otherFeeDialog.formData.electricTotal"
                           clearable/>
        </el-form-item>
        <el-form-item label="总收水费：" prop="waterTotal">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%" v-model="otherFeeDialog.formData.waterTotal"
                           clearable/>
        </el-form-item>
        <el-form-item label="总交电费：" prop="payWaterTotal">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%" v-model="otherFeeDialog.formData.payWaterTotal"
                           clearable/>
        </el-form-item>
        <el-form-item label="总交水费：" prop="payElectricTotal">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%" v-model="otherFeeDialog.formData.payElectricTotal"
                           clearable/>
        </el-form-item>
        <el-form-item label="利润：" prop="income">
          <el-input-number :precision="2" disabled :step="0.1" :min="0" style="width: 100%" v-model="otherFeeDialog.formData.income"
                           clearable/>
        </el-form-item>
        <el-form-item label="费用日期：" prop="feeDate">
          <el-date-picker
            v-model="otherFeeDialog.formData.feeDate"
            type="month"
            placeholder="请选择月份"
            value-format="yyyy-MM"
            style="width: 100%">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="dialog-btn">
        <el-button @click="otherFeeDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="saveOrUpdateData" :loading="loading">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import {getPageList, deleteData, saveOrUpdateData} from "@/api/otherFee";

export default {
  data() {
    return {
      table: {
        query: {
          page: 1,
          size: 10,
          feeDate: '',
          feeYear: ''
        },
        total: 0,
        data: []
      },
      otherFeeDialog: {
        formData: {
          electricTotal: 0,
          waterTotal: 0,
          payWaterTotal: 0,
          payElectricTotal: 0,
          income: 0,
          feeDate: ''
        },
        visible: false
      },
      rules: {
        electricTotal: [
          {trigger: 'change', required: true, message: '请输入总收电费'}
        ],
        waterTotal: [
          {trigger: 'change', required: true, message: '请输入总收水费'}
        ],
        payWaterTotal: [
          {trigger: 'blur', required: true, message: '请输入总交水费'}
        ],
        payElectricTotal: [
          {trigger: 'blur', required: true, message: '请输入总交电费'}
        ],
        income: [
          {trigger: 'blur', required: true, message: '请输入利润'}
        ],
        feeDate: [
          {trigger: 'blur', required: true, message: '请选择费用日期'}
        ]
      },
      loading: false,
      tableLoading: false,
      isEdit: false
    }
  },
  mounted() {
    this.search(true)
  },
  watch: {
    profit(newVal) {
      this.otherFeeDialog.formData.income = newVal
    }
  },
  computed: {
    profit() {
      return ((this.otherFeeDialog.formData.electricTotal || 0) + (this.otherFeeDialog.formData.waterTotal || 0)) - ((this.otherFeeDialog.formData.payWaterTotal || 0) + (this.otherFeeDialog.formData.payElectricTotal || 0))
    }
  },
  methods: {
    // 搜索框查询
    search(flag) {
      this.tableLoading = true
      if (flag) {
        this.table.query.page = 1
      }
      const params = {
        current: this.table.query.page,
        size: this.table.query.size,
        feeDate: this.table.query.feeDate,
        feeYear: this.table.query.feeYear
      }
      getPageList(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.table.data = response.data
          this.table.total = response.count
        } else {
          // 查询失败
          this.$message.error('查询失败!')
        }
        this.tableLoading = false
      })
    },
    // 修改
    saveOrUpdateData() {
      this.loading = true
      this.$refs['otherFeeForm'].validate(async (valid) => {
        if (valid) {
          saveOrUpdateData(this.otherFeeDialog.formData).then(response => {
            if (response.code == 200) {
              // 操作成功
              this.$message.success('操作成功!')
              this.otherFeeDialog.visible = false
              this.search(false)
            } else {
              // 操作失败
              this.$message.error('操作失败!')
            }
            this.loading = false
          })
        } else {
          this.loading = false
        }
      })
    },
    // 打开弹窗
    openDialog(data, isEdit) {
      this.isEdit = isEdit
      this.rentRecordIds = []
      if (!isEdit) {
        // 重置数据
        this.otherFeeDialog.formData = {
          electricTotal: 0,
          waterTotal: 0,
          payWaterTotal: 0,
          payElectricTotal: 0,
          income: 0,
          feeDate: ''
        }
      } else {
        this.otherFeeDialog.formData = JSON.parse(JSON.stringify(data))
      }
      this.otherFeeDialog.visible = true
      // 清空验证信息
      this.$nextTick(() => {
        this.$refs.otherFeeForm.clearValidate()
      })
    },
    // 页码变更
    currentPageChange(page) {
      this.table.query.page = page
      this.search(false)
    },
    // 删除
    deleteData(id) {
      this.$confirm('此操作将永久删除水电收支信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteData(id).then(response => {
          if (response.code == 200) {
            // 操作成功
            this.$message.success('操作成功!')
            this.search(false)
          } else {
            // 操作失败
            this.$message.error(response.data)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    //导出
    handleExcelExport() {
      window.open("/hrApi/otherFee/export?token=" + localStorage.getItem("token"));
      this.$message.success("导出成功！");
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/back/otherFee.vue